import { render } from "./faqsPage.vue?vue&type=template&id=deb1d170&scoped=true"
import script from "./faqsPage.vue?vue&type=script&lang=js"
export * from "./faqsPage.vue?vue&type=script&lang=js"

import "./faqsPage.vue?vue&type=style&index=0&id=deb1d170&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb1d170"]])

export default __exports__